import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=7bab699c&lang=pug"
import script from "./Clients.js?vue&type=script&lang=js&external"
export * from "./Clients.js?vue&type=script&lang=js&external"
import style0 from "./Clients.vue?vue&type=style&index=0&id=7bab699c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports